__turbopack_context__.v({
  "banner": "Banner-module-scss-module__biTUJq__banner",
  "close_button": "Banner-module-scss-module__biTUJq__close_button",
  "default": "Banner-module-scss-module__biTUJq__default",
  "error": "Banner-module-scss-module__biTUJq__error",
  "icon": "Banner-module-scss-module__biTUJq__icon",
  "info": "Banner-module-scss-module__biTUJq__info",
  "info__title": "Banner-module-scss-module__biTUJq__info__title",
  "success": "Banner-module-scss-module__biTUJq__success",
});
